module.exports = __webpack_public_path__ + "question-mark.png";